import {
  AggregateLiquidityData,
  StressLevel,
} from '../../fundAssetLiquidationTime/table';
import React, { ReactElement, useMemo } from 'react';
import {
  buildMainData,
  createAgTableColumns,
  createAgTableColumnsPDF,
  csvAggregateLiquidation,
} from './ag-table.data';
import GridItem from '../../../../layout/GridComponents/GridItem';
import CustomTable from '../../../../tables/CustomTable';
import { liquidityMap } from '../AggregateLiquidationPage';
import { CustomColumn } from '../../../../../types/components/tables/tableTypes';
import { useSelector } from 'react-redux';
import { createSectionFundsSelector } from '../../../../../redux/pages/selectors';
import { demoRowStyle } from '../../../../../utilities/demoFundUtils';

interface Props {
  selectedLevel: StressLevel;
  pageModelData: any;
  loading?: boolean;
  section: string;
  pageId?: string;
}

function AggregateLiquidationTable(props: Props): ReactElement {
  const funds = useSelector(
    createSectionFundsSelector(props.section, props.pageId),
  );
  // `external_name` in the payload is untyped and may be either the internal
  // fund id or the display name, so accept a match on either.
  const demoFundNames = useMemo(
    () =>
      new Set(
        (funds ?? [])
          .filter((fund) => fund.isDemoFund)
          .flatMap((fund) => [fund.id, fund.name]),
      ),
    [funds],
  );
  const tableData = props.pageModelData
    ? buildMainData(props.pageModelData, props.selectedLevel, demoFundNames)
    : [];
  const columns = createAgTableColumns(props.selectedLevel);
  const pdfColumns = createAgTableColumnsPDF(props.selectedLevel);

  return (
    <GridItem xs={12} card>
      <CustomTable<AggregateLiquidityData>
        data={tableData}
        csvFields={csvAggregateLiquidation}
        showToolbar
        toolbarComponents={{
          toolbarTitle: liquidityMap[props.selectedLevel],
        }}
        additionalDetailForPdf={`Stress Level: ${liquidityMap[props.selectedLevel]}`}
        columns={columns as unknown as CustomColumn<AggregateLiquidityData>[]}
        options={{
          paging: false,
          exportButton: true,
          pageSizeOptions: [5, 10, 20, tableData.length],
          rowStyle: demoRowStyle(),
        }}
        loading={props.loading ?? false}
      // pdfColumns={pdfColumns}
      />
    </GridItem>
  );
}

export default AggregateLiquidationTable;
